module.exports = __webpack_public_path__ + "static/media/number-of-sports-video.aeb4bd95.mp4";